import { Text } from '@/components/shared/element/text';

interface DealerPanelContentHeadlineProps {
  label: string;
}

export const DealerPanelContentHeadline: React.FunctionComponent<
  DealerPanelContentHeadlineProps
> = (props: DealerPanelContentHeadlineProps) => {
  return (
    <Text
      as="h4"
      size="text-base"
      font="bold"
      variant="text-gray"
      css={{ marginBottom: '$space-4' }}
    >
      {props.label}
    </Text>
  );
};

DealerPanelContentHeadline.displayName = 'SectionDealerPanelContentHeadline';
